function updateCart(data) {
  const $html = $(data);
  const cartCount = $html.find(".cart-count").text();
  const $itemsHTML = $html.find(".header .cart__holder");
  const $cartDrawer = $(".cart-drawer__form");
  $(".cart-count").text(cartCount);
  $cartDrawer.find(".cart__holder").remove();
  $cartDrawer.append($itemsHTML);
  $(".select-wrapper select").not(".selectric-hide-select select").selectric();
  $(".cart-item").addClass("active");
}

$(".shopify-product-form").on("submit", function(e) {
  e.preventDefault();
  const $this = $(this);
  const serializeData = $this.serialize();
  $.ajax({
    url: $this.attr("action"),
    data: serializeData
  }).done(function(data) {
    updateCart(data);
  });
});

const $headerItems = $(".header__utility-items");

$headerItems.on("click", ".cart__item .close", function(e) {
  const $this = $(this);
  const removeUrl = $this.data("close");
  $.ajax({
    url: removeUrl
  }).done(function() {
    $this.closest(".cart__item").slideUp(function() {
      $(this).remove();
      if ($(".cart__items").children().length === 0) {
        $.ajax({
          url: "/cart"
        }).done(function(data) {
          $(".cart__holder").html(`<p>${$(data).find(".cart__empty h2").text()}</p>`);
        });
      }
    });
  });
});

$headerItems.on("change", ".qty", function() {
  const $this = $(this);
  $.ajax({
    url: "/cart/update.js",
    type: "POST",
    dataType: "json",
    data: `${$this.attr("name")}=${$this.val()}`
  }).done(function(data) {
    if (data.item_count == 0) {
      $.ajax({
        url: "/cart"
      }).done(function(data) {
        $(".cart__holder").html(`<p>${$(data).find(".cart__empty h2").text()}</p>`);
      });
    } else {
      if ($this.val() == 0) {
        $this.closest(".cart__item").remove();
      }
      $headerItems.find(".cart__foot .total-price").text(Shopify.formatMoney(data.total_price));
    }
    $headerItems.find(".cart-count").text(data.item_count);
  });
});

$(".header__utility-items").on("click", ".qty-wrapper span", function() {
  var $this = $(this);
  var qtyInput = $this.parent().find("input");
  var qtyInputVal = qtyInput.val();
  qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

  if ($this.hasClass("qty-plus")) {
    qtyInputVal++;
    qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
  } else {
    qtyInputVal--;
    qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
  }
  qtyInput.val(qtyInputVal).trigger("change");
});



// WEBPACK FOOTER //
// ../assets/js/ajax-cart.js